import React from "react";
import { ThemeProvider } from "styled-components";
import { theme, themeChakraUi } from "./styles/theme";
import { GlobalStyle } from "./styles/globalStyles";
import { Outlet } from "react-router-dom";
import LoginContextProvider from "./context/loginContext";
import UsuallyContextProvider from "@context/usuallyContex";
import { ChakraProvider } from "@chakra-ui/react";
import OportunityContexProvider from "@context/oportunityContex";
import MenuSideBar from "@components/common/MenuSideBar";
import ErrorBoundary from "@components/common/ErrorBoundary";
import maintenanceServiceInstance from "@services/Maintenance/MaintanceService";
import Spinner from "@components/common/Spinner";
import Maintenance from "./pages/Maintenance";
import ChatBot from "@components/common/ChatBot";
import AppDownloadModal from "@components/common/AppDownloadModal";
import { useAppDownloadModal } from "@hook/useAppDownloadModal";

export const ThemeContext: any = React.createContext(null);

const AppContent: React.FC = () => {
  const { showModal, closeModal } = useAppDownloadModal();

  const appLayout = React.useMemo(
    () => (
      <>
        <GlobalStyle />

        {/*
          Layout original restaurado — mantém o mesmo comportamento
          que estava em produção antes da alteração.
          O MenuSideBar gerencia seu próprio posicionamento (fixed/absolute),
          e o Outlet recebe 100% da largura disponível normalmente.
        */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100vw",
          }}
        >
          <MenuSideBar />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
            }}
          >
            <Outlet />
          </div>
        </div>

        {/* ChatBot — posição original mantida */}
        <div
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          <ChatBot />
        </div>

        {/* Modal de download do app — apenas para mobile web */}
        <AppDownloadModal isOpen={showModal} onClose={closeModal} />
      </>
    ),
    [showModal, closeModal],
  );

  return appLayout;
};

function App() {
  const [themes, setThemes] = React.useState("");
  const themeGlobal = React.useMemo(() => ({ themes, setThemes }), [themes]);

  const [isMaintenanceMode, setIsMaintenanceMode] = React.useState(false);
  const [isCheckingMaintenance, setIsCheckingMaintenance] =
    React.useState(true);

  React.useEffect(() => {
    let cancelled = false;

    const checkMaintenanceStatus = async () => {
      try {
        const response =
          await maintenanceServiceInstance.getStatusMaintenance();
        if (!cancelled) setIsMaintenanceMode(response);
      } catch (error) {
        console.error("Erro ao verificar status de manutenção:", error);
        if (!cancelled) setIsMaintenanceMode(false);
      } finally {
        if (!cancelled) setIsCheckingMaintenance(false);
      }
    };

    checkMaintenanceStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  if (isCheckingMaintenance) {
    return (
      <ChakraProvider theme={themeChakraUi}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spinner />
        </div>
      </ChakraProvider>
    );
  }

  if (isMaintenanceMode) {
    return (
      <ChakraProvider theme={themeChakraUi}>
        <Maintenance />
      </ChakraProvider>
    );
  }

  return (
    <ErrorBoundary>
      <LoginContextProvider>
        <UsuallyContextProvider>
          <OportunityContexProvider>
            <ThemeContext.Provider value={themeGlobal}>
              <ThemeProvider theme={theme}>
                <ChakraProvider theme={themeChakraUi}>
                  <AppContent />
                </ChakraProvider>
              </ThemeProvider>
            </ThemeContext.Provider>
          </OportunityContexProvider>
        </UsuallyContextProvider>
      </LoginContextProvider>
    </ErrorBoundary>
  );
}

export default App;
